import script from "./StarInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./StarInput.vue?vue&type=script&setup=true&lang=ts"

import "./StarInput.vue?vue&type=style&index=0&id=0aea0c6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aea0c6a"]])

export default __exports__